import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title align-items-center d-flex flex-wrap" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Create Third Party ")
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_11 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.breadcrumbs[1][$setup.breadcrumbs[1].length - 1]), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/third-party/new",
            class: "btn btn-flex btn-success"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Datatable, {
        ref: "tableRef",
        "table-header": $setup.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.isStoreLoading,
        total: _ctx.totalStore
      }, _createSlots({
        "cell-no": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index +
            1 +
            _ctx.storeTableOption.rowsPerPage * (_ctx.storeTableOption.currentPage - 1)), 1)
        ]),
        "cell-startDate": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.createdAt, 'DD/MM/YYYY')), 1)
        ]),
        "cell-endDate": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.createdAt, 'DD/MM/YYYY')), 1)
        ]),
        "cell-isActive": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'), 1)
        ]),
        "cell-editView": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: `/third-party/${row.id}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr001.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _: 2
      }, [
        _renderList($setup.tableHeader.filter(
            (data) =>
              !['startDate', 'endDate', 'editView', 'isActive'].includes(
                data.key
              )
          ), (item, i) => {
          return {
            name: `cell-${item.key}`,
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
            ])
          }
        })
      ]), 1032, ["table-header", "table-data", "loading", "total"])
    ])
  ]))
}